import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { FileInput as UppyFileInput } from '@uppy/react';
import { Box } from '@chakra-ui/react';

const FileInputCustom = ({ children, uppy }) => {
  const inputRef = useRef(null);

  const handleClick = useCallback(() => {
    inputRef?.current?.container?.querySelector('input[type=file]')?.click();
  }, [inputRef]);

  return (
    <Box>
      <Box display="none">
        <UppyFileInput ref={inputRef} uppy={uppy} pretty={false} />
      </Box>
      {React.cloneElement(children, {
        ...children.props,
        onClick: handleClick,
      })}
    </Box>
  );
};

FileInputCustom.propTypes = {
  children: PropTypes.node.isRequired,
  uppy: PropTypes.shape({}).isRequired,
};

FileInputCustom.defaultProps = {};

export default FileInputCustom;